import { FC, useState } from 'react'

import CONFIG from '../../../../config'
import { EDocumentType } from '../../../models'
import { FamilyGroupFilter } from '..'
import { Loading, Alert, Text } from '../../UI'
import { useAuth } from '../../../hooks'

type ExamsOthersPropsProps = {
  className?: string,
  userToken: string,
  familyFilter: any,
  familyFilterSelected: string,
  onFamilyFilterChange?(patientId: string): void
}

const option: any = {
  width: '100%',
  height: '100%',
  src: CONFIG.APP.EXAM_IFRAME_URL,
  title: ''
}

const ExamsOthers:FC<ExamsOthersPropsProps> = ({ className = '', userToken, familyFilter, familyFilterSelected, onFamilyFilterChange }) => {
  const userCurrent = useAuth()
  const [loadIframe, setLoadIframe] = useState<boolean>(true)

  const onFilterChange = (userId: string) => {
    setLoadIframe(true)
    if(onFamilyFilterChange) onFamilyFilterChange(userId)
  }

  const { document_type_id } = userCurrent.getInfo()

  return (
    <div className={className}>
      <div className="laboratory-iframe-wrapper">
        <div className="pt-20 pr-10">
          <FamilyGroupFilter
            data={familyFilter.data}
            dataSelected={familyFilterSelected}
            onChange={onFilterChange}
          />
        </div>

        {document_type_id === EDocumentType.passport &&
          <div className="mt-20 mb-20 px-10">
            <Alert type="INFO">
              <Text size="13" lineHeight="2">{CONFIG.MESSAGE.EXAM.LABORATORY_ALERT}</Text>
            </Alert>
          </div>
        }

        <iframe
          src={`${option.src}${userToken}`}
          width={option.width}
          height={option.height}
          frameBorder="0"
          scrolling="no"
          title={option.title}
          className={`laboratory-iframe ${className}`}
          onLoad={() => setLoadIframe(false)}
        />
        {loadIframe && <Loading overlay className="laboratory-iframe-loading" />}
      </div>
    </div>
  )
}

export { ExamsOthers }